export default "__VITE_ASSET__D1gL79Af__"